import { gql } from '__generated__';

export default gql(`
  query GetAppsForProject($project_id: ID!) {
    project(id: $project_id) {
      id
      organisation_name
      apps {
        ...AppFields
      }
    }
  }
`);

export const AppFieldsFragment = gql(`
  fragment AppFields on App {
    id
    name
    description
    logo_url
    connect_url
    purchases_analytics_url
    created_at
    requested_permissions
    authorizations {
      id
      permissions
      created_at
      project {
        id
        organisation_name
      }
    }
  }
`);
